import { Component, Inject, Optional, ViewChild } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { BaseComponent } from '../../shared/base-components/base.component';
import { ModalSize } from '../../shared/services/modal/mvd-modal.enum';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { ArtifactComponent } from './artifact.component';
import { RegenerateArtifactContext } from './regenerate-artifact-context.model';
import { RegenerateArtifactModalComponent } from './regenerate-artifact-modal.component';

export class ArtifactContext {
    constructor(public businessTransactionNumberId: number, public businessTransactionDetails: string) { }
}

@Component({
    templateUrl: 'artifact-modal.html'
})
export class ArtifactModalComponent extends BaseComponent {
    businessTransactionNumberId: number;
    businessTransactionDetails: string;
    public modalTitle = 'Service Artifacts & Notes';
    public secondaryTableTitle = 'Notes';
    public primaryTableTitle = 'Service Details';
    public isDocumentViewRestrictedCheckEnabled = true;
    public artifactRegenerateDocumentTypes: any[] = new Array();
    @ViewChild('artifact') artifactComponent: ArtifactComponent;

    constructor(public dialogRef: MatDialogRef<ArtifactModalComponent>,
        private modalService: MvdModalService,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: ArtifactContext) {
        super();

        this.businessTransactionNumberId = this.data.businessTransactionNumberId;
        this.businessTransactionDetails = this.data.businessTransactionDetails;
    }

    public cancel() {
        this.dialogRef.close();
    }

    ngOnInit() {
    }

    /**
    * show artifacts modal
    * @param businessTransactionNumberId
    */
    public showArtifactsModal() {
        // Manually insert empty business unit to drop down list
        const emptyDocumentType = { value: null, label: '' };
        this.artifactRegenerateDocumentTypes.unshift(emptyDocumentType);

        const data = new RegenerateArtifactContext(
            this.businessTransactionNumberId,
            this.businessTransactionDetails,
            this.artifactRegenerateDocumentTypes);

        this.modalService.open(RegenerateArtifactModalComponent, data, ModalSize.Medium)
            .afterClosed()
            .subscribe(() => this.artifactComponent.refreshArtifacts());
    }

    public artifactsLoaded = (artifactRegenerateDocumentTypes: any): void => {
        this.artifactRegenerateDocumentTypes = artifactRegenerateDocumentTypes;
    };
}
